import { ContentSection, ContentPage } from "@/src/components/Content";
import ExternalLink from "@/src/components/ExternalLink";

const photoCreditLinks = [
  {
    name: "Local Energy",
    url: "https://www.flickr.com/photos/tentenuk/18489240870/",
    linkText: "Moss Community Energy Launch",
  },
  {
    name: "Community Assistance",
    url: "https://www.flickr.com/photos/governortomwolf/51027382488/",
    linkText:
      "The Delaware County Office of Services for the Aging and Community Transit partner to provide shopping services for seniors - Elaine Lawley - Delaware County",
  },
  {
    name: "Food Production + Distribution",
    url: "https://www.flickr.com/photos/seanpants/4634710248/in/photostream/",
    linkText: "Harvest Party!",
  },
  {
    name: "Rain barrels",
    url: "https://www.flickr.com/photos/darinrmcclure/6986975310/in/photostream/",
    linkText: "Rain Barrel #connected",
  },
];

const Credits = () => (
  <ContentPage title="Photo Credits">
    <ContentSection>
      <p>The images on the homepage are credited as follows:</p>
      <ul>
        {photoCreditLinks.map(({ name, url, linkText }, idx) => (
          <li key={idx}>
            <strong>{name}</strong>
            {` - `}
            <ExternalLink url={url} newPage>
              {linkText}
            </ExternalLink>
          </li>
        ))}
      </ul>
    </ContentSection>
  </ContentPage>
);

export default Credits;
